import {ConstructionSiteStatus} from "@/models/Enums";

export enum QueryTimeSpan {
  Initial,
  Year,
  AllTime
}

export default class ToolbarModel {
  public searchTerm: string = "";
  public status: ConstructionSiteStatus | null = ConstructionSiteStatus.Active;
  public siteNumber: string | null = null;
  public siteName: string | null = null;
  public customerNumber: string | null = null;
  public customerName: string | null = null;
  public invoiceReference: string | null = null;
  public externalReference: string | null = null;
  public address: string | null = null;
  public queryTimeSpan: QueryTimeSpan = QueryTimeSpan.AllTime;
  public filtersSubmitted: boolean = false;
}

export function isAnySearchCriteriaSet(model: ToolbarModel): boolean {
  return (
    !!model.searchTerm ||
    !!model.customerNumber ||
    !!model.customerName ||
    !!model.siteNumber ||
    !!model.siteName ||
    !!model.invoiceReference ||
    !!model.externalReference ||
    !!model.address
  );
}